import DynamicForm from "@/common/DynamicForm";
import { IntakeSectionHeader, StyledGridRow } from "@/common/styles";
import { Form } from "antd";
import { useEffect, useState } from "react";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import { convertApiFields, isNonEmptyVariable } from "@/util/common_function";

const AdditionalPersonalInformation = ({ header }) => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [form] = Form.useForm();
  const [apiFields, setApiFields] = useState([]);
  const [additionalPersonalInfo, setAdditionalPersonalInfo] = useState(null);
  const fullSearch = useSelector(state => state.fullSearch);

  // --- Fetch API Field Definitions ---
  useEffect(() => {
    getFieldsFromExtraAPI();
  }, []);

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      const apin = bookings?.bio?.[0]?.bioExtra?.[0];
      setAdditionalPersonalInfo(apin);
    } else {
      setAdditionalPersonalInfo(null);
    }
  }, [bookings]);

  // Set the form’s initial values from formData (after transforming for display).
  useEffect(() => {
    if (isNonEmptyVariable(additionalPersonalInfo)) {
      form.setFieldsValue(additionalPersonalInfo);
    } else {
      form.resetFields();
    }
  }, [additionalPersonalInfo]);

  const getFieldsFromExtraAPI = () => {
    api
      .get(API_ENDPOINTS.getBioExtra)
      .then((response) => {
        const tableData = response?.data?.filter(
          (d) => d?.columnName !== "BioExtraID" && d?.columnName !== "BioID"
        );
        let converted = convertApiFields(tableData, "BioExtra");
        console.log(converted);

        setApiFields(converted);
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  };

  // Merge current visible form values with hidden fields from formData, then transform keys before saving.
  const updateForm = (currentValues) => {
    dispatch(
      setBookings({
        bio: [
          {
            ...bookings?.bio?.[0],
            bioExtra: [
              {
                ...bookings?.bio?.[0]?.bioExtra?.[0],
                ...currentValues,
              },
            ],
          },
        ],
      })
    );
  };

  return (
    <>
      {header && (
        <IntakeSectionHeader>
          <span>{header}</span>
        </IntakeSectionHeader>
      )}
      <Form
        form={form}
        onBlur={(e) => {
          const values = form.getFieldsValue();
          updateForm(values);
        }}
        disabled={!bookingsFieldsEnabled}
      >
        <StyledGridRow gutter={[16]}>
          {apiFields.map((sf, index) => (
            <DynamicForm
              key={index}
              formAttributes={sf}
              form={form}
              bookingsFieldsEnabled={bookingsFieldsEnabled}
              fullSearch={fullSearch}
            />
          ))}
        </StyledGridRow>
      </Form>
    </>
  );
};

export default AdditionalPersonalInformation;
